import { render } from "./HelpDetail.vue?vue&type=template&id=256f310d&scoped=true"
import script from "./HelpDetail.vue?vue&type=script&lang=js"
export * from "./HelpDetail.vue?vue&type=script&lang=js"

import "./HelpDetail.vue?vue&type=style&index=0&id=256f310d&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256f310d"]])

export default __exports__